import {ColourPickerDialogComponentController, ColourPickerDialogData} from "../dialog/ColourPickerDialogComponent";
import {IModalService} from "angular-ui-bootstrap";
import {Observable} from "rxjs/Observable";
import "rxjs/add/observable/fromPromise";
import {IScope} from "angular";

export class ColourPickerService {

    public static id = "colourPickerService";

    /** @ngInject */
    public constructor(private $uibModal: IModalService) {

    }

    public open(data: ColourPickerDialogData): Observable<string | null> {
        const instance = this.$uibModal.open({
            templateUrl: "app/components/colour-picker/dialog/ColourPickerDialogComponent.html",
            controller: ColourPickerDialogComponentController,
            controllerAs: "ctrl",
            resolve: {
                data
            }
        });
        return Observable.fromPromise(instance.result);
    }
}
